import { Component, Input, OnInit } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { Workbook } from 'exceljs';
import { CRMReportRequest } from '../crm-data-by-zip-territory.component';
import { DataGridCreatedEvent, excelCustomFormats } from '../crm-report-datagrid/crm-report-datagrid-defns';
import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

@Component({
  selector: 'app-crm-report-crm-suspects',
  templateUrl: './crm-report-crm-suspects.component.html',
  styleUrls: ['./crm-report-crm-suspects.component.scss']
})
export class CrmReportCrmSuspectsComponent implements OnInit {

  @Input()
  reportRequest: CRMReportRequest;

  childDataGrids: Array<DataGridCreatedEvent> = new Array<DataGridCreatedEvent>();

  crmSuspects_heading1: string = '';
  crmSuspects_heading2: string = '';
  crmSuspects_heading3: string = '';
  crmSuspects_heading4: string = '';

  showSubHeadings: boolean = false;

  workbook: any;
  excelColMaxWidth = 30;
  excelColMinWidth = 12;
  
  constructor() { }

  ngOnInit(): void {
    this.setReportHeadings();
  }

  setReportHeadings(){    
    this.setReportHeadings_crmSuspects();       
  }

  setReportHeadings_crmSuspects(){
    if(this.reportRequest.territoryValue){
      this.crmSuspects_heading1 = 'Suspects in ' + this.reportRequest.salesSubRegionValue + ':' + this.reportRequest.territoryValue;
    }else if(this.reportRequest.postCodeValue){
      this.crmSuspects_heading1 = 'Suspects within ' + String(this.reportRequest.radiusMiles) + ' miles of ' + this.reportRequest.postCodeValue;
    }

    this.crmSuspects_heading2 = 'AIR PRODUCTS CONFIDENTIAL - INTERNAL USE ONLY';
    this.crmSuspects_heading3 = 'A missing plant means nothing within 300 miles.';    

  }

  async exportExcel(e) {

    this.workbook = new Workbook();

    //All Leads
    let crmSuspects_datagrid_idx = this.childDataGrids.findIndex(event => event.reportType == 'CRM_Suspects');

    if(crmSuspects_datagrid_idx >= 0){
      await this.createCRMSuspects_worksheet(
        this.childDataGrids[crmSuspects_datagrid_idx].dataGridComponent,
        this.childDataGrids[crmSuspects_datagrid_idx].columnFormatDetails,
      );
    }
    
    await this.workbook.xlsx.writeBuffer()
    .then(function (buffer: BlobPart) {
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'LeadListByTerritoryZip.xlsx');
    });

  }

  //Export All Leads Details tab
  async createCRMSuspects_worksheet(dataGrid: DxDataGridComponent, columnFormatDetails?: Array<any>){

    const worksheet = this.workbook.addWorksheet('LeadListByTerritoryZip');

    await exportDataGrid({
      component: dataGrid.instance,
      worksheet: worksheet,
      topLeftCell: { row: 5, column: 1 },
    }).then((cellRange) => {

      //Set default alignment and font properties at the worksheet level
      worksheet.eachRow((row, i) => {
        row.alignment = {
          vertical: 'top',          
          wrapText: true
        }

        row.font = {
          name: 'Tahoma',
          size: 10
        }

        row.border = {
          top: {style:'thin', color: {argb:'000000'}},
          left: {style:'thin', color: {argb:'000000'}},
          bottom: {style:'thin', color: {argb:'000000'}},
          right: {style:'thin', color: {argb:'000000'}}
        };
      });        
      
      
    
    }).then(() => {

      //Prepare Sheet header-1
      worksheet.mergeCells('A1:P1');      
      worksheet.getCell('A1').value = {
        'richText': [
          {'font': {'size': 18,'color': {'argb': '1C3A70'},'name': 'Tahoma'},'text': this.crmSuspects_heading1},          
        ]
      };

      worksheet.mergeCells('A2:P2');      
      worksheet.getCell('A2').value = {
        'richText': [
          {'font': {'size': 10,'color': {'argb': 'FF0000'},'name': 'Tahoma'},'text': this.crmSuspects_heading2},          
        ]
      };

      worksheet.mergeCells('A3:P3');      
      worksheet.getCell('A3').value = {
        'richText': [
          {'font': {'size': 10,'color': {'argb': '000000'},'name': 'Tahoma'},'text': this.crmSuspects_heading3},          
        ]
      };

      worksheet.mergeCells('A4:P4');      
      worksheet.getCell('A4').value = {
        'richText': [
          {'font': {'size': 10,'color': {'argb': '000000'},'name': 'Tahoma'},'text': this.crmSuspects_heading4},          
        ]
      };

      const topLeftAlign = {
        vertical: 'top',
        horizontal: 'left',
        wrapText: true
      };

      const no_border_style = {
        top: {style:'thin', color: {argb:'FFFFFF'}},
        left: {style:'thin', color: {argb:'FFFFFF'}},
        bottom: {style:'thin', color: {argb:'FFFFFF'}},
        right: {style:'thin', color: {argb:'FFFFFF'}}
      };      

      const headerRows = worksheet.getRows(1,4);

      headerRows.forEach((row,i) => {         
        row.border = no_border_style;
        row.alignment = topLeftAlign;
      });
      
      worksheet.getRow(1).height = 24; 
      worksheet.getRow(2).height = 15;
      worksheet.getRow(3).height = 15;
      worksheet.getRow(4).height = 15;

      //Set format for table header row
      const tableHeaderRow = worksheet.getRow(5);
      
      tableHeaderRow.fill = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'1C3A70'},
      };                  

      tableHeaderRow.font = { name: 'Tahoma', size: 11, color: { argb: 'ffffff' }, bold: true };
      tableHeaderRow.height = 42;
         
      //fill style
      const header_fill_1 = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'0000FF'},
      };            

      //Change fill color and border for certain header cells
      [11,12,13,14].forEach((i) => {
        tableHeaderRow.getCell(i).fill = header_fill_1;
      });      

      //Adjust column widths for better appearance    
      worksheet.columns.forEach((column,i) => {

        if(column.width > this.excelColMaxWidth){
          column.width = this.excelColMaxWidth;
        }else if(column.width < this.excelColMinWidth){
          column.width = this.excelColMinWidth;
        }

        //adjust column width based on the header text length
        if(tableHeaderRow.getCell(i+1).value.length > 16){            
          column.width = 18.5;
        }        
      });

      //Apply the excel formatting equivalent to what was done in the grid
      columnFormatDetails.forEach((item,i) => {
        worksheet.getColumn(item.col).numFmt = excelCustomFormats.find(fmt => fmt.gridFmt == item.gridFmt)?.excelFmt;
      });

      worksheet.getColumn('AL').width = 20;
      worksheet.getColumn('AM').width = 20;

    });

  }

  //Receive datagrid created events and store the event meta-data.
  //This will be used for the export-to-excel functionality
  onDataGridCreated(event: DataGridCreatedEvent){       
    
    this.crmSuspects_heading4 = `Report has ${event.totalRowCount} rows.  All potential customers are listed for the selected Territories (only) regardless of distance from a plant.`
    this.showSubHeadings = true;
    this.childDataGrids.push(event);
  }
}
